import { StatusDiv } from "./StatusTagStyles";

// TODO: Determine if we need to wrap this always within a div element.
// In case the answer is positive, we should do it here, otherwise we
// should add it when importing this element.
function StatusTag(props) {
  const { status } = props;
  return (
    <StatusDiv status={status.category}>
      <p>{status.label.toUpperCase()}</p>
    </StatusDiv>
  );
}

export default StatusTag;
